import ironlakChart from "@assets/17549603132406154244386378879029_1754960318882.jpg";

export default function ColorChart() {
  return (
    <div className="min-h-screen bg-dark-base text-white p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header */}
        <div className="text-center space-y-2">
          <h1 className="text-4xl font-bold text-neon-green glow-effect" data-testid="title-color-chart">
            Ironlak Colour Chart
          </h1>
          <p className="text-gray-300 text-lg" data-testid="subtitle-color-chart">
            Professional graffiti color collection for street artists
          </p>
        </div>

        {/* Official Ironlak Color Chart */}
        <div className="bg-dark-elevated p-6 rounded-lg border border-gray-700">
          <h2 className="text-2xl font-bold text-neon-green mb-4 text-center">
            Ironlak Colour Chart
          </h2>
          <div className="flex justify-center">
            <img 
              src={ironlakChart} 
              alt="Ironlak Colour Chart"
              className="max-w-full h-auto rounded-lg shadow-lg border border-gray-600"
              data-testid="image-color-chart"
            />
          </div>
        </div>

        {/* Color Information */}
        <div className="bg-dark-elevated p-6 rounded-lg border border-gray-700">
          <h3 className="text-xl font-bold text-neon-green mb-4">About Ironlak Colors</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-300">
            <div>
              <h4 className="font-semibold text-white mb-2">Series 1 Collection</h4>
              <p className="text-sm">
                Premium colour pencils featuring vibrant pigments designed specifically for street artists. 
                Each color is carefully formulated for maximum coverage and durability on various surfaces.
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-white mb-2">Professional Quality</h4>
              <p className="text-sm">
                Ironlak colors provide consistent flow, excellent opacity, and weather resistance. 
                Perfect for both beginners learning techniques and professionals creating masterpieces.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}